import { GET, POST, PUT, DELETE } from "../../api";

export const findAll = async (
  id = "",
  currentPage = 1,
  perPage = 10,
  search = "",
  from = "",
  to = "",
) => {
  return await GET(`/admin/results/control/bets`);
};

export const ChangeResult = async (periodId, data) => {
  return await POST(`/admin/results/control/change/${periodId}`, data);
};
